export const PLAY_STORE_APP_URL = 'https://play.google.com/store/apps/details?id=com.defimedoc&hl=fr'
export const APPLE_STORE_APP_URL = 'https://apps.apple.com/fr/app/défimedoc/id1454498277'
